/**
 * Görüntüleme modu (21 Ekim 2026, kullanıcı).
 *
 * Sistem yöneticisi Sistem Yönetimi'nden bir kuruma "Görüntüle" ile girince
 * kurumun ekranlarını patron gibi görüyor ama hiçbir şeyi değiştiremiyor.
 * Değiştirmeyi ekran ekran kapatmak yerine sunucuya giden tek kapıda
 * durduruyoruz: bu moddayken yalnız okuma istekleri geçiyor. Veritabanı
 * çoğunu zaten reddediyordu ama hepsini değil (açık adisyona tur eklemek
 * gibi), ve reddedilen yazma telefonda takılan kayıt olarak kalırdı.
 *
 * Kurum tarafında iz kalmıyor: "son görülme" yalnız kurumun kendi
 * personelinden hesaplanıyor.
 */

let on = false

export function setViewMode(next: boolean): void {
  on = next
}

export function isViewMode(): boolean {
  return on
}

/** Yalnız okuyan uzak fonksiyonlar; görüntüleme modunda geçebiliyor. */
const READ_RPCS = new Set([
  'is_superadmin',
  'tenant_exists',
  'tenant_of_login',
  'tenant_activity',
  'tenant_staff_activity',
  'public_menu',
])

/** Bu isteğin görüntüleme modunda geçip geçmeyeceği. */
export function allowedInViewMode(url: string, method: string): boolean {
  const m = method.toUpperCase()
  if (m === 'GET' || m === 'HEAD' || m === 'OPTIONS') return true
  // Oturumun yenilenmesi ve çıkış: yazma değil, kendi oturumumuz.
  if (url.includes('/auth/v1/')) return true
  const rpc = url.match(/\/rest\/v1\/rpc\/([a-z_]+)/)
  if (rpc) return READ_RPCS.has(rpc[1])
  return false
}

/** Engellenen istekte ekranda uyarı göstermek için. */
export const VIEW_MODE_EVENT = 'adissoo:view-mode-blocked'

/**
 * Supabase istemcisinin fetch'i. Görüntüleme modunda yazma isteğini sunucuya
 * göndermeden 403 ile geri çeviriyor ve ekrana haber veriyor.
 */
export const viewModeFetch: typeof fetch = async (input, init) => {
  if (on) {
    const url = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url
    const method = init?.method ?? (input instanceof Request ? input.method : 'GET')
    if (!allowedInViewMode(url, method)) {
      window.dispatchEvent(new Event(VIEW_MODE_EVENT))
      return new Response(
        JSON.stringify({ code: 'VIEW_MODE', message: 'Görüntüleme modunda değişiklik yapılamaz.' }),
        { status: 403, headers: { 'Content-Type': 'application/json' } },
      )
    }
  }
  return fetch(input, init)
}
